import { Collapse, Input, Slider, Tree } from "antd"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import CustomButton from "../../../components/CustomButton"
import { useTranslation } from "react-i18next"
import { getObjectFuncTypes } from "../../NRI/ReObjectFunctionTypes/store/actions";
import CustomTree from "./CustomTree"

const Filters = ({ filters, setFilters, setSearchValue }) => {
    const dispatch = useDispatch()
    const { objectFuncTypes } = useSelector((state) => state.reObjectFunctionTypeReducer)
    const { t } = useTranslation(['common', 'project', 'action'])

    const [checkedKey, setCheckedKey] = useState([])
    const [active, setActive] = useState([])
    const [isOpenedPanel, setIsOpenedPanel] = useState(true)
    const [tempFilters, setTempFilters] = useState({
        floors: [null, null],
        appartments: [null, null],
        commonSquare: [null, null],
    })
    const [tree, setTree] = useState([])
    const [filtersDefaultValues, setFiltersDefaultValues] = useState({
        floors: [0, 20],
        appartments: [0, 227],
        commonSquare: [0, 2270]
    })

    useEffect(() => {
        if (objectFuncTypes.length === 0) {
            dispatch(getObjectFuncTypes())
        }
    }, [])

    useEffect(() => {
        if (objectFuncTypes) {
            setTree(objectFuncTypes?.filter(n => n.code3 === '00').map(item => {

                return {
                    key: item.id,
                    title: `${item.name} (${item.q})`,
                    children: objectFuncTypes?.filter(n => n.parentId === item.id)
                        .map((el) => {
                            return {
                                key: el.id,
                                title: `${el.name} (${el.q})`,
                                parentId: el.parentId,
                                children: objectFuncTypes?.filter(n => n.parentId === el.id)
                                    .map(m => ({ key: m.id, parentId: m.parentId, title: `${m.name} (${m.q})` }))
                            }
                        })
                }
            }))
        }
    }, [objectFuncTypes])

    const onSelect = (selectedKeys, info) => {
        setCheckedKey(selectedKeys)
        const type = objectFuncTypes.find(type => type.id === selectedKeys[0])
        setFilters(
            {
                ...filters,
                code1: type.code1,
                code2: type.code2,
                code3: type.code3,
                code4: type.code4,
                page: 1
            }
        )
    };

    const resetFilters = () => {
        setCheckedKey([])
        setFilters({
            floors: [null, null],
            appartments: [null, null],
            commonSquare: [null, null],
            page: 1
        })
        setTempFilters({
            ...tempFilters,
            floors: [null, null],
            appartments: [null, null],
            commonSquare: [null, null],
            code1: null,
            code2: null,
            code3: null,
            code4: null,
            page: 1
        })
        if (setSearchValue)
            setSearchValue('')
        setActive([])
    }

    const openCollapse = (key) => {
        setIsOpenedPanel(!isOpenedPanel)
    }

    const validateNumber = (type, index) => {
        return (event) => {
            if (event.target.value < 0)
                changeFilters(0, type, index)
            else if (index === 1 && filters[type][0] && event.target.value < filters[type][0])
                changeFilters(Number(filters[type][0]) + 1, type, index)
            else if (index === 0 && filters[type][1] && event.target.value > filters[type][1])
                changeFilters(Number(filters[type][1]) - 1, type, index)
            else if (event.target.value > filtersDefaultValues[type][1])
                changeFilters(filtersDefaultValues[type][1], type, index)
            else changeFilters(event.target.value, type, index)
        }
    }

    const changeFilters = (number, type, index) => {
        const tempF = {
            ...tempFilters
        }
        tempF[type][index] = Number(number)
        setTempFilters(tempF)
    }

    const handleFilter = (type, index) => {
        return (event) => {
            const reg = /^-?\d*(\.\d*)?$/
            if (reg.test(event?.target?.value)) {
                changeFilters(event.target.value, type, index)
            }
        }
    }

    const applyFilters = () => {
        setFilters(tempFilters)
    }

    return (
        <div className="projects__filters">
            <CustomTree
                tree={tree}
                filters={tempFilters}
                setFilters={setTempFilters}
                active={active}
                setActive={setActive}
            ></CustomTree>
            <div className="filters__inputs">
                {/* <div className="filters__inputs__item">
                    <p className="filters__input__title" >{t('project:numberOfStoreys')}</p>
                    <div className="filters__inputs__wrapper">
                        <Input
                            className="filters__input"
                            value={tempFilters?.floors[0]}
                            placeholder={filtersDefaultValues?.floors[0]}
                            onChange={handleFilter('floors', 0)}
                            onBlur={validateNumber('floors', 0)}
                        />
                        <div className="filters__inputs__separator"> </div>
                        <Input
                            className="filters__input"
                            value={tempFilters?.floors[1]}
                            placeholder={filtersDefaultValues?.floors[1]}
                            onChange={handleFilter('floors', 1)}
                            onBlur={validateNumber('floors', 1)}

                        />
                    </div>
                </div>
                <div className="filters__inputs__item">
                    <p className="filters__input__title">{t('project:appartments')}</p>
                    <div className="filters__inputs__wrapper">
                        <Input
                            className="filters__input"
                            value={tempFilters?.appartments[0]}
                            placeholder={filtersDefaultValues?.appartments[0]}
                            onChange={handleFilter('appartments', 0)}
                            onBlur={validateNumber('appartments', 0)}
                        />
                        <div className="filters__inputs__separator"> </div>
                        <Input
                            className="filters__input"
                            value={tempFilters?.appartments[1]}
                            placeholder={filtersDefaultValues?.appartments[1]}
                            onChange={handleFilter('appartments', 1)}
                            onBlur={validateNumber('appartments', 1)}

                        />
                    </div>
                </div>
                <div className="filters__inputs__item">
                    <p className="filters__input__title" >{t('project:commonSquare')}</p>
                    <div className="filters__inputs__wrapper">
                        <Input
                            className="filters__input"
                            value={tempFilters?.commonSquare[0]}
                            placeholder={filtersDefaultValues?.commonSquare[0]}
                            onChange={handleFilter('commonSquare', 0)}
                            onBlur={validateNumber('commonSquare', 0)}
                        />
                        <div className="filters__inputs__separator"> </div>
                        <Input
                            className="filters__input"
                            value={tempFilters?.commonSquare[1]}
                            placeholder={filtersDefaultValues?.commonSquare[1]}
                            onChange={handleFilter('commonSquare', 1)}
                            onBlur={validateNumber('commonSquare', 1)}

                        />
                    </div>
                </div> */}
            </div>
            <div className="filters__button__wrapper">
                <CustomButton
                    onClick={applyFilters}
                >
                    {t('common:apply')}
                </CustomButton>
                <CustomButton
                    onClick={resetFilters}
                    type='grey'
                >
                    {t('action:reset')}
                </CustomButton>
            </div>
        </div>)
}

export default Filters